export var RatingQuestion;
(function (RatingQuestion) {
    RatingQuestion["Q1"] = "Was your recent maintenance work order completed?";
    RatingQuestion["Q2"] = "Please rate your recent maintenance experience overall.";
    RatingQuestion["Q3"] = "Please rate how easy it was to schedule your maintenance request.";
    RatingQuestion["Q4"] = "Please rate your recent experience with the maintenance tech.";
    RatingQuestion["Q5"] = "Please share any compliments or comments.";
    RatingQuestion["Q6Start"] = "How likely are you to recommend living in a";
    RatingQuestion["Q6End"] = "home?";
    RatingQuestion["Q7"] = "We are sorry your service has not been completed. Please provide additional information on the current maintenance need for our maintenance team and you will be contacted.";
})(RatingQuestion || (RatingQuestion = {}));
export var RatingStarType;
(function (RatingStarType) {
    RatingStarType["Q2"] = "Q2";
    RatingStarType["Q3"] = "Q3";
    RatingStarType["Q4"] = "Q4";
})(RatingStarType || (RatingStarType = {}));
export var WOReferenceType;
(function (WOReferenceType) {
    WOReferenceType[WOReferenceType["ReactiveWO"] = 0] = "ReactiveWO";
    WOReferenceType[WOReferenceType["RecurrentWO"] = 1] = "RecurrentWO";
})(WOReferenceType || (WOReferenceType = {}));
export var InHouseTech;
(function (InHouseTech) {
    InHouseTech[InHouseTech["InHouseTech"] = 30] = "InHouseTech";
})(InHouseTech || (InHouseTech = {}));
export var WorkCompletedStatusType;
(function (WorkCompletedStatusType) {
    WorkCompletedStatusType[WorkCompletedStatusType["YES"] = 1] = "YES";
    WorkCompletedStatusType[WorkCompletedStatusType["NO"] = 2] = "NO";
})(WorkCompletedStatusType || (WorkCompletedStatusType = {}));
export var LinkObjectTypeData;
(function (LinkObjectTypeData) {
    LinkObjectTypeData[LinkObjectTypeData["RecurrentWo"] = 1] = "RecurrentWo";
    LinkObjectTypeData[LinkObjectTypeData["ReactiveWo"] = 2] = "ReactiveWo";
})(LinkObjectTypeData || (LinkObjectTypeData = {}));
